import Bus from '@/assets/js/bus.js';
export default {
  data() {
    return {
      tabVal: '',
      showRightAside: false,
      lastTabName: '',
      tabPosition: 'left',
      showUnread: false,
      showComponent: '',
      loadChatBox: true
    };
  },
  props: {
    organizationInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tagNameInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    nickNameInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    rtilCode: {
      default: ''
    },
    raiseHandList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    changeHandList: {
      default: ''
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    allPartyMembers: {
      type: Array,
      default: function () {
        return [];
      }
    },
    partyCode: {
      default: ''
    }
  },
  created() {
    Bus.$on('changePartyAddress', val => {
      if (!val) return;
      this.tabVal = '';
      this.showRightAside = false;
      this.lastTabName = '';
    });
    Bus.$on('raiseHand', v => {});
  },
  methods: {
    callback(obj) {
      this.$emit('callback', obj);
    },
    chatCallback(obj) {
      if (obj.type == 'unreadInfo') {
        this.showUnread = false;
        Object.keys(obj.data).forEach(keys => {
          if (obj.data[keys].unRead) {
            this.showUnread = true;
          }
        });
      } else {
        this.$emit('callback', obj);
      }
    },
    clickTab(tabInfo) {
      const {
        name
      } = tabInfo;
      if (name == 'close') {
        this.loadChatBox = false;
        this.showUnread = false;
      } else {
        this.loadChatBox = true;
      }
      if (this.lastTabName == name || name == 'close') {
        this.tabVal = '';
        this.lastTabName = '';
        this.$emit('hideRightAside');
      } else {
        this.lastTabName = name;
        this.$emit('showRightAside');
      }
      if (this.tabVal == 'chat') {
        this.showComponent = true;
      } else {
        this.showComponent = false;
      }
    }
  }
};